module.exports = __webpack_public_path__ + "media/images/icons8-home-ac52b302eedd9b915a682050dde8b1c4.svg";